import { DatePicker as D, Grid as G, Input as g, Radio as B, Checkbox as C, Rate as U, TimePicker as W, TreeSelect as H, Slider as J, InputNumber as X, Select as Z, AutoComplete as K, Row as I, Col as R, Form as u, Divider as Q, Popconfirm as ee, Button as _ } from "antd";
import { jsx as o, Fragment as b, jsxs as A } from "react/jsx-runtime";
import N, { useMemo as m, useState as $, useEffect as q, useContext as P, createElement as L, useRef as te, useCallback as ae } from "react";
import { CloseCircleFilled as re, PlusSquareOutlined as ne } from "@ant-design/icons";
import ie from "dayjs";
const oe = (e) => /* @__PURE__ */ o("input", { type: "hidden", value: e.value, onChange: e.onChange }), se = (e) => /* @__PURE__ */ o("span", { ...e, children: e.text }), { useBreakpoint: de } = G, le = (e) => {
  const t = de();
  return /* @__PURE__ */ o(b, { children: t.lg ? /* @__PURE__ */ o(D, { ...e }) : /* @__PURE__ */ o(D, { ...e, inputReadOnly: !0 }) });
}, ce = (e) => /* @__PURE__ */ o(
  C,
  {
    checked: e.value === !0,
    onChange: (t) => e.onChange && e.onChange(t.target.checked),
    children: e.children
  }
), fe = (e) => /* @__PURE__ */ o(g, { ...e, onChange: (t) => e.onChange?.(t.target.value?.toUpperCase()) }), v = (e, t) => {
  const a = e;
  return (d) => {
    const r = m(() => {
      const n = t.put ? { ...t.put, ...d } : { ...d };
      if (t.remove && (Array.isArray(t.remove) ? t.remove.forEach((i) => delete n[i]) : delete n[t.remove]), t.style && (n.style = n.style ? { ...t.style, ...n.style } : t.style), t.className && (n.className = `${t.className} ${n.className ?? ""}`.trim()), t.encode) {
        const i = n.onChange;
        i && (n.onChange = (s) => {
          s == null ? i(void 0) : s.target !== void 0 && s.target !== null ? i(
            s.target.value === void 0 || s.target.value === null ? void 0 : t.encode?.(s.target.value)
          ) : i(t.encode?.(s));
        });
      }
      if (t.decode) {
        const i = n.value;
        i !== void 0 && (n.value = t.decode(i));
      }
      return t.map ? t.map(n) : n;
    }, [d]);
    return /* @__PURE__ */ o(a, { ...r });
  };
}, k = (e) => {
  if (e.options && Array.isArray(e.options) && e.options.length > 0 ? (console.log(typeof e.options), typeof e.options[0] == "string" ? e.options = e.options.map((t) => ({ label: t, value: t })) : e.options = e.options.map((t) => ({ label: t.name, value: t.value }))) : e.options && typeof e.options == "object" && (e.options = Object.entries(e.options).map((t) => ({ label: t[1], value: t[0] }))), e.mode === "tags") {
    const t = e.onChange;
    e.onChange = (a) => t?.(a.filter((d) => d.trim() !== ""));
  }
  return e.getPopupContainer = (t) => t.parentNode, e;
}, me = (e) => {
  const [t, a] = $(e.value);
  return q(() => a(e.value), [e.value]), /* @__PURE__ */ o(J, { ...e, value: t, onChange: a, onAfterChange: e.onChange });
};
class w {
}
w.typeAdapters = {
  string: g,
  capstring: fe,
  password: g.Password,
  text: v(g.TextArea, { put: { autoSize: { minRows: 4, maxRows: 10 } } }),
  multilineStringArray: v(g.TextArea, {
    encode: (e) => e?.split(`
`),
    decode: (e) => e?.join(`
`),
    put: { autoSize: { minRows: 4, maxRows: 10 } }
  }),
  number: v(X, { style: { display: "block", width: "100%" } }),
  hidden: oe,
  label: se,
  email: v(g, { put: { type: "email" } }),
  date: v(le, {
    put: { format: "YYYY/MM/DD" },
    encode: (e) => e.format("YYYY-MM-DD"),
    decode: (e) => ie(e),
    style: { width: "100%" }
  }),
  radio: B.Group,
  check: C.Group,
  checkbox: C,
  boolean: ce,
  search: g.Search,
  select: v(Z, { map: k }),
  acSelect: v(K, { map: k }),
  rate: U,
  slider: me,
  time: W,
  tree: H
};
w.allValidators = [
  {
    name: "invalid-answers",
    message: "Invalid Unacceptable Responses.",
    validator: async (e, t, a, d) => {
      const r = a.getFieldValue([...d, "answers"]) ?? [], n = t ?? [];
      for (const i of n)
        if (r.indexOf(i) === -1)
          throw Error(`Answer "${i}" is not in all answer list.`);
    }
  },
  {
    name: "equals",
    message: "Should be equals",
    validator: async (e, t, a) => {
      if (a.getFieldValue(e.to) !== t)
        throw Error("Not equal");
    }
  },
  {
    name: "depends",
    message: "empty",
    validator: async (e, t, a) => {
      if (a.getFieldValue(e.to) === void 0 && t.value === "")
        throw Error("empty");
    }
  },
  {
    name: "passwordPolicy",
    message: "Should be equals",
    validator: async (e, t) => {
      const a = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*"'()+,-./:;<=>?[\\\]_`{|}~])(?=.{8,})/;
      if (t === void 0 || t.length === 0 || a.test(t))
        console.log("");
      else
        throw Error(
          "Password should contain more than 8 characters and at least 1 upper case character, 1 lower case character, 1 number and 1 special character"
        );
    }
  },
  // {
  //   name: 'phone',
  //   message: 'Should be valid phone number',
  //   validator: async (_: any, value: any) => {
  //     console.log('XXXXX', value);
  //     if (value === undefined || value === '') {
  //       console.log('XXXXXY', value);
  //       return;
  //     }
  //     if (!value || isValidPhoneNumber(value)) {
  //       console.log('XXXXXZ', value);
  //       return;
  //     } else {
  //       console.log('XXXXXE', value);
  //       throw Error('Invalid phone number');
  //     }
  //   },
  // },
  // {
  //   name: 'phoneVerification',
  //   message: 'Should be valid phone number',
  //   validator: async (_: any, value: any) => {
  //     if (value === undefined || value.phone === '') {
  //       return;
  //     }
  //     if (!value.phone || isValidPhoneNumber(value.phone)) {
  //       return;
  //     } else {
  //       throw Error('Invalid phone number');
  //     }
  //   },
  // },
  // {
  //   name: 'whatsappVerification',
  //   message: 'Should be valid phone number',
  //   validator: async (_: any, value: any) => {
  //     if (value === undefined || value.whatsapp === '') {
  //       return;
  //     }
  //     if (!value.whatsapp || isValidPhoneNumber(value.whatsapp)) {
  //       return;
  //     } else {
  //       throw Error('Invalid phone number');
  //     }
  //   },
  // },
  {
    name: "array-item-equals",
    message: "Duplicate value",
    validator: async (e, t, a, d) => {
      let r = a.getFieldsValue();
      for (let n = 0; n < d.length - 1; n += 1)
        r = r?.[d[n]];
      if (r && Array.isArray(r)) {
        const n = d[d.length - 1];
        for (let i = 0; i < r.length; i += 1)
          if (i !== n) {
            if (r[n].type === void 0)
              return;
            if (typeof e.compare == "function")
              e.compare?.(r[n], r[i]);
            else if (typeof e.compare == "string" || typeof e.compare == "number") {
              if (typeof r[n]?.[e.compare] == "string" && typeof r[i]?.[e.compare] == "string") {
                if (r[n]?.[e.compare].toLowerCase() === r[i]?.[e.compare].toLowerCase())
                  throw Error(e.message ?? "Duplicate value");
              } else if (r[n]?.[e.compare] === r[i]?.[e.compare])
                throw Error(e.message ?? "Duplicate value");
            } else if (Array.isArray(e.compare)) {
              let s = !1;
              for (const l of e.compare)
                if (r[n]?.[l] === r[i]?.[l])
                  s = !0;
                else {
                  s = !1;
                  break;
                }
              if (s)
                throw Error(e.message ?? "Duplicate value");
            }
          }
      }
    }
  },
  // {
  //   name: 'nic',
  //   message: 'Should be a valid NIC',
  //   validator: async (_: any, value: any) => {
  //     if (value === undefined || value === '') {
  //       return;
  //     }
  //     const pattern = /^([0-9]{9}[x|X|v|V]|[0-9]{12})$/m;
  //     if (!value.match(pattern)) {
  //       throw Error('Not a NIC');
  //     }
  //     try {
  //       const datePart = value.substr(value.length === 10 ? 2 : 4, 3);
  //       let date = parseInt(datePart);
  //       if (date > 500) {
  //         date = date - 500;
  //       }
  //       if (date <= 0 || date > 366) {
  //         throw Error('Not a NIC');
  //       }
  //     } catch (e) {
  //       throw Error('Not a NIC');
  //     }
  //   },
  // },
  {
    name: "email",
    message: "Should be valid E-mail",
    validator: async (e, t) => {
      if (t === void 0 || t === "")
        return;
      const a = /^[\w-.]+@([\w-]+\.)+[\w-]{2,8}$/g;
      if (!t.match(a))
        throw Error("Not a Valid E-mail");
    }
  },
  {
    name: "plusNumber",
    message: "Should be Positive value",
    validator: async (e, t) => {
      if (!(t === void 0 || t === 0) && +t < 0)
        throw Error("Not a Positive Value");
    }
  },
  {
    name: "durationValidator",
    validator: async (e, t) => {
      if (t) {
        if (t.from === void 0)
          throw new Error(`${e.fromDate ?? "From date"} is required`);
        if (!t.present) {
          if (t.to === void 0)
            throw new Error(`${e.toDate ?? "End date"} is required`);
          if (t.to < t.from)
            throw new Error(
              `${e.fromDate ?? "End date"} should be greater than ${e.fromDate ?? "From date"}`
            );
        }
      }
    }
  },
  {
    name: "endDateValidator",
    message: "Should be a valid end date",
    validator: async (e, t) => {
      if (console.log({ value: t }), !t.to && t.present === void 0)
        throw Error("Should be a valid end date");
    }
  },
  {
    name: "salaryValidator",
    message: "Should be Correct Salary Value",
    validator: async (e, t) => {
      if (t.salary === void 0 || t.salary === 0)
        throw Error("Salary is required");
    }
  },
  {
    name: "descriptionValidator",
    message: "",
    validator: async (e, t) => {
      if (!t)
        return;
      if (t.replace(/<[^>]+>/g, "") === "")
        throw Error("Description is required");
    }
  },
  {
    name: "salaryEmpty",
    message: "Salary is Required",
    validator: async (e, t) => {
      if (t.salary === void 0)
        throw Error("Salary is Required");
    }
  },
  {
    name: "urlValidator",
    message: "Please enter a valid website link",
    validator: async (e, t) => {
      if (t === null || t === "" || t === void 0)
        return;
      const a = new RegExp(
        "^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$",
        "i"
      );
      if (!t.match(a))
        throw Error("Please enter a valid website link");
    }
  },
  {
    name: "linkedinValidator",
    message: "Invalid Linkedin URL",
    validator: async (e, t) => {
      if (t === null || t === "" || t === void 0)
        return;
      const a = new RegExp(
        "^(https?:\\/\\/)?((www|\\w\\w)\\.)?linkedin.com\\/((in\\/[^/]+/?)|(pub\\/[^\\/]+/((\\w|\\d)+\\/?){3}))$",
        "i"
      );
      if (!t.match(a))
        throw Error("Invalid Linkedin URL");
    }
  },
  {
    name: "blankValidator",
    message: "shouldn't be blank ",
    validator: async (e, t) => {
      if (t === null || t === "" || t === void 0)
        return;
      const a = new RegExp("^\\s*$", "i");
      if (t.match(a))
        throw Error("white space ");
    }
  }
  // {
  //   name: 'blankValidatorAutoComplete',
  //   message: "shouldn't be blank ",
  //   validator: async (_a: any, value: AutocompleData) => {
  //     if (value === null || value?.value === '' || value?.value === undefined) {
  //       return;
  //     }
  //     const pattern = new RegExp('^\\s*$', 'i');
  //
  //     if (value?.value.match(pattern)) {
  //       throw Error('white space ');
  //     } else {
  //       return;
  //     }
  //   },
  // },
  // {
  //   name: 'maxAutoComplete',
  //   message: "shouldn't be blank ",
  //   validator: async (_a: any, value: AutocompleData) => {
  //     if (value === null || value?.value === '' || value?.value === undefined) {
  //       return;
  //     }
  //
  //     if (value?.value.length > _a.max) {
  //       throw Error('white space ');
  //     } else {
  //       return;
  //     }
  //   },
  // },
  // {
  //   name: 'mobile',
  //   message: 'Should be Valid number',
  //   validator: async (_: any, value: string) => {
  //     if (value === undefined || isValidPhoneNumber(value)) {
  //       return;
  //     }
  //     throw Error('Not a Valid Phone number');
  //   },
  // },
];
const x = N.createContext({
  adapters: w.typeAdapters,
  validators: w.allValidators
}), ue = (e) => {
  const t = P(x), { adapters: a, validators: d } = t, { adapters: r, validators: n } = e, i = m(
    () => ({ ...r ?? {}, ...a }),
    [a, r]
  ), s = m(
    () => [...n ?? [], ...d],
    [d, n]
  );
  return /* @__PURE__ */ o(x.Provider, { value: { adapters: i, validators: s }, children: e.children });
}, S = N.createContext({ form: void 0 }), F = (e) => {
  const { field: t, adapters: a } = e, d = P(S), r = m(() => {
    const c = t.type;
    return typeof c == "string" ? c : c.hasOwnProperty("object") ? "object" : "array";
  }, [t.type]), n = m(() => {
    const c = e.fieldData?.name;
    return c === void 0 ? [t.id] : Array.isArray(c) ? [...c, t.id] : typeof c == "number" ? [c] : [c, t.id];
  }, [t.id, e]), i = m(() => {
    if (!t.options?.rules || t.options.rules.findIndex(
      (f) => f.hasOwnProperty("validator") && typeof f.validator == "string"
    ) === -1)
      return t.options;
    const c = { ...t.options };
    return c.dependencies && (c.dependencies = c.dependencies.map(
      (f) => typeof f == "string" ? [...e.parentPath, f] : f
    )), c.rules = c.rules.map((f) => {
      if (!f.hasOwnProperty("validator") || typeof f.validator != "string")
        return f;
      const p = e.validationAdapters[f.validator];
      if (p === void 0)
        return f;
      const h = f.message ? f.message : p.message;
      return (O) => ({
        ...f,
        message: h,
        validator: async (M, Y) => p.validator(M, Y, O, e.parentPath, t)
      });
    }), c;
  }, [t, e.parentPath, e.validationAdapters]), s = m(() => r === "array" && t.type.addText ? t.type.addText : "Add", [r, t.type]), l = m(() => r === "array" && t.type.fixed === !0, [r, t.type]), T = m(
    () => a[r] ? a[r] : a.string,
    [a, r]
  );
  if (r === "array")
    return /* @__PURE__ */ o(u.Item, { label: t.name, ...i, name: n, children: /* @__PURE__ */ o(u.List, { name: n, children: (c, f) => /* @__PURE__ */ A(b, { children: [
      c.map((p, h) => /* @__PURE__ */ o("div", { children: /* @__PURE__ */ A(
        "div",
        {
          className: "schema-form-item",
          style: { display: "flex", position: "relative" },
          children: [
            t.numlist && /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o("p", { children: h > 8 ? h + 1 : `0${h + 1}` }) }),
            h !== 0 && /* @__PURE__ */ o(Q, { style: { position: "absolute", left: 0, right: 0, top: -30 } }),
            /* @__PURE__ */ o("div", { style: { flexGrow: 1 }, children: /* @__PURE__ */ o(
              E,
              {
                schema: [t.type.array],
                fieldData: p,
                adapters: e._adapters,
                validationAdapters: e._validationAdapters,
                parentPath: [...e.parentPath, e.field.id, h]
              }
            ) }),
            !l && /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o(
              ee,
              {
                placement: "top",
                title: t.confirmation ?? "Are you sure you want to delete?",
                onConfirm: () => f.remove(h),
                okText: "Yes",
                okButtonProps: { danger: !0 },
                cancelText: "No",
                children: /* @__PURE__ */ o(_, { type: "text", danger: !0, icon: /* @__PURE__ */ o(re, {}) })
              }
            ) })
          ]
        },
        h
      ) }, h)),
      !l && (t.type.max ?? 100) > c.length && /* @__PURE__ */ A(
        _,
        {
          style: { display: "block", width: "100%", textAlign: "left", color: "#009E52" },
          onClick: () => f.add(t.props?.defaultValue),
          children: [
            /* @__PURE__ */ o(ne, {}),
            s
          ]
        }
      )
    ] }) }) });
  if (r === "object")
    return /* @__PURE__ */ o(
      E,
      {
        schema: t.type.object,
        fieldData: { name: n },
        parentPath: [...e.parentPath]
      }
    );
  const j = T, z = {
    ...typeof t.props == "function" ? t.props(d.value ? d.value : {}, d.form, e.parentPath) : t.props
  };
  return /* @__PURE__ */ o(u.Item, { ...i, label: t.name, name: n, children: /* @__PURE__ */ o(j, { ...z }) });
}, he = (e) => {
  const { field: t, adapters: a } = e;
  return Array.isArray(t) ? /* @__PURE__ */ o(I, { gutter: 16, style: { flexGrow: 1 }, children: t.map((d, r) => /* @__PURE__ */ L(R, { span: 24, ...d.layout, key: r }, /* @__PURE__ */ o(
    F,
    {
      field: d,
      adapters: a,
      fieldData: e.fieldData,
      validationAdapters: e.validationAdapters,
      _adapters: e._adapters,
      _validationAdapters: e._validationAdapters,
      parentPath: e.parentPath
    }
  ))) }) : /* @__PURE__ */ o(
    F,
    {
      field: t,
      adapters: a,
      fieldData: e.fieldData,
      validationAdapters: e.validationAdapters,
      _adapters: e._adapters,
      _validationAdapters: e._validationAdapters,
      parentPath: e.parentPath
    }
  );
}, V = (e) => {
  const { schema: t, adapters: a, validationAdapters: d } = e, r = P(S), n = m(() => {
    const i = [];
    let s = [];
    for (const l of t)
      l.visible !== void 0 && (typeof l.visible == "boolean" && !l.visible || typeof l.visible == "function" && !l.visible(r.value ? r.value : {}, r.form, e.parentPath)) || (l.layout ? s.push(l) : (s.length > 0 && (i.push(s), s = []), i.push(l)));
    return s.length > 0 && i.push(s), i;
  }, [r.form, r.value, e.parentPath, t]);
  return /* @__PURE__ */ o(b, { children: n.map((i, s) => /* @__PURE__ */ o(
    he,
    {
      field: i,
      adapters: a,
      fieldData: e.fieldData,
      validationAdapters: d,
      _adapters: e._adapters,
      _validationAdapters: e._validationAdapters,
      parentPath: e.parentPath
    },
    s
  )) });
}, E = (e) => {
  const { schema: t } = e, a = P(x), d = a.adapters, r = m(() => {
    const s = {};
    return a.validators.forEach((l) => s[l.name] = l), e.validationAdapters && e.validationAdapters.forEach((l) => s[l.name] = l), s;
  }, [a.validators, e.validationAdapters]), [n, i] = m(() => {
    const s = Array.isArray(t) ? t : [t], l = s.length > 0 && s[0].hasOwnProperty("fields") ? "columns" : "fields";
    return [s, l];
  }, [t]);
  return n.length === 0 ? /* @__PURE__ */ o(b, {}) : i === "fields" ? /* @__PURE__ */ o(
    V,
    {
      schema: n,
      adapters: d,
      validationAdapters: r,
      fieldData: e.fieldData,
      _adapters: e.adapters,
      _validationAdapters: e.validationAdapters,
      parentPath: e.parentPath ? e.parentPath : []
    }
  ) : /* @__PURE__ */ o(I, { gutter: 16, children: n.map((s, l) => /* @__PURE__ */ L(R, { ...s.layout, key: l }, /* @__PURE__ */ o(
    V,
    {
      schema: s.fields,
      adapters: d,
      validationAdapters: r,
      fieldData: e.fieldData,
      parentPath: e.parentPath ? e.parentPath : []
    }
  ))) });
}, ye = (e) => {
  const [t, a] = $(), d = te(!1), r = ae(
    (n, i) => {
      a(i), e.onValuesChange?.(n, i);
    },
    [e]
  );
  return q(() => {
    if (e.valueChangeNotif === d.current)
      return;
    d.current = e.valueChangeNotif ?? !1;
    const n = e.form?.getFieldsValue();
    a(n);
  }, [r, e.form, e.valueChangeNotif]), // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  /* @__PURE__ */ o(S.Provider, { value: { value: t, form: e.form }, children: /* @__PURE__ */ o(
    u,
    {
      className: "antd-schema-form",
      scrollToFirstError: { behavior: "smooth", scrollMode: "always" },
      ...e,
      onValuesChange: r,
      children: e.children
    }
  ) });
}, Pe = (e, t) => t?.body?.validationErrors ? (e.setFields(
  Object.entries(t.body.validationErrors).map((a) => ({
    name: a[0].split("."),
    errors: [a[1]]
  }))
), !0) : !1, y = ye;
y.useForm = u.useForm;
y.useFormInstance = u.useFormInstance;
y.useWatch = u.useWatch;
y.Item = u.Item;
y.List = u.List;
y.ErrorList = u.ErrorList;
y.Provider = u.Provider;
y.Items = E;
y.ConfigProvider = ue;
export {
  v as MapProps,
  y as default,
  Pe as setValidationErrors
};
